import StringUtil from 'gw-portals-util-js/StringUtil';

export default {
    getStyleFunction: function getStyleFunction(styles) {
        return function (prefix, type, flavour, state) {
            var key = '' + prefix + type + flavour + state;
            return styles[key];
        };
    },
    getActiveStateFunction: function getActiveStateFunction(stateFunc) {
        return function () {
            var activeState = stateFunc() || '';
            // Capitalise the states first char
            activeState = StringUtil.capitalizeFirstLetter(activeState);
            return activeState;
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/common/tilesUtilFunctions.js
// module id = 1165
// module chunks = 0